import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const themeObj = {
  palette: {
    common: {
      black: '#000',
      white: '#fff',
    },
    background: {
      paper: '#fff',
      default: '#fafafa',
      lightGrey: '#efefef',
      grey: '#dadada',
      dark: '#303030',
    },
    primary: {
      light: 'rgba(60, 141, 188, 1)',
      main: 'rgba(109, 153, 169, 1)',
      dark: 'rgba(90, 126, 139, 1)',
      contrastText: 'rgba(245, 245, 245, 1)',
    },
    secondary: {
      ultraLight: 'rgba(250, 245, 221, 1)',
      light: 'rgba(242, 226, 153, 1)',
      main: 'rgba(240, 220, 131, 1)',
      dark: 'rgba(219, 200, 120, 1)',
      contrastText: 'rgba(10, 2, 3, 1)',
    },
    tertiary: {
      light: '#715D6C',
      main: '#523A4C',
      dark: '#44303F',
      contrastText: 'rgba(245, 245, 245, 1)',
    },
    error: {
      light: 'rgba(223, 114, 111, 1)',
      main: 'rgba(217, 83, 79, 1)',
      dark: 'rgba(178, 68, 65, 1)',
      contrastText: '#fff',
    },
    success: {
      light: '#79C479',
      main: '#5cb85c',
      dark: '#4C974C',
      contrastText: '#fff',
    },
    light: {
      light: 'rgba(255, 255, 255, 1)',
      main: 'rgba(230, 230, 230, 1)',
      dark: '#d5d5d5',
      contrastText: 'rgba(10, 2, 3, 1)',
    },
    disabled: {
      light: '#A09FA0',
      main: '#7A797A',
      dark: '#545354',
      contrastText: '#aaaaaa',
    },
    text: {
      primary: 'rgba(10, 2, 3, 1)',
      secondary: 'rgba(10, 2, 3, 0.54)',
      light: 'rgba(245, 245, 245, 1)',
      disabled: 'rgba(10, 2, 3, 0.38)',
      hint: 'rgba(10, 2, 3, 0.38)',
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 16,
    fontFamily: [
      'Source Sans Pro',
      'Helvetica Neue',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  spacing: factor => `${factor}rem`,
};

const mainTheme = responsiveFontSizes(createMuiTheme(themeObj));
export default mainTheme;